import React from 'react';
import './EmptyValue.css';

function EmptyValue({ label = 'Not set', onClick, className = '' }) {
  if (onClick) {
    return (
      <button
        className={`empty-value empty-value--clickable ${className}`}
        onClick={onClick}
        type="button"
      >
        {label}
      </button>
    );
  }
  return <span className={`empty-value ${className}`}>{label}</span>;
}

export default EmptyValue;
